import React from 'react';
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import logo from '../assets/logo.png';

const Navbar = () => {
  const navigate = useNavigate();  // Initialize the navigate function

  // Function to navigate to the landing page
  const goToLandingPage = () => {
    navigate('/');  // This assumes '/' is your landing page route
  };

  return (
    <nav style={styles.navbar}>
      {/* Logo */}
      <div style={styles.logo}>
        <img src={logo} alt="Logo" style={styles.logoImage} />
      </div>

      {/* Back to Landing Page Button */}
      <button 
        style={styles.landingPageButton} 
        onClick={goToLandingPage}>
        Go Back to Home
      </button>

      {/* Logout Button (Commented out) */}
      {/* <button style={styles.logoutButton} onClick={() => alert('Logout')}>
        Login/Logout
      </button> */}
    </nav>
  );
};

const styles = {
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: '#ffff',
    color: '#fff',
    width: '100vw',           // Ensures full width
    position: 'fixed',         // Fixes the navbar to the top
    top: 0,                    // Aligns the navbar to the top
    left: 0,                   // Aligns the navbar to the left edge
    zIndex: 1000,              // Ensures the navbar stays above other elements
  },
  logo: {
    flex: '1',                 // Ensures the logo stays to the left
  },
  logoImage: {
    height: '40px',
    marginLeft: '5px'            // Adjust size as needed
  },
  landingPageButton: {
    backgroundColor: '#936fe0',
    color: '#fff',
    border: 'none',
    padding: '5px 10px',
    borderRadius: '15px',
    cursor: 'pointer',
    marginRight: '20px',          // Adjust the margin as needed
    height: '40px',
  },
  logoutButton: {
    backgroundColor: '#936fe0',
    color: '#fff',
    border: 'none',
    padding: '5px 10px',
    borderRadius: '15px',
    cursor: 'pointer',
    marginRight: '60px',
    height: '40px',
  },
};

export default Navbar;
